<div class="p-grid">
	<div class="p-col-12 p-md-6">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'tally']"></fa-icon>
				</span>
				<span class="overview-title">Tracked Customers</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="p-col">
					<div class="overview-number">
						{{ customerService.customerSummary.recordCount | number }}
					</div>
					<div class="overview-subtext">Total tracked customers</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'user-crown']"></fa-icon>
				</span>
				<span class="overview-title">Top Customer</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="p-col-6">
					<div class="overview-number">
						{{ app.references.toTitleCase(customerService.customerSummary.topCustomer.firstName) }}
						{{ app.references.toTitleCase(customerService.customerSummary.topCustomer.lastName) }}
					</div>
				</div>
				<div class="p-col-6">
					<div class="overview-subtext">{{ customerService.customerSummary.topCustomer.visitCount }} visits</div>
					<div class="overview-subtext">{{ customerService.customerSummary.topCustomer.totalRevenue | currency }} total spend</div>
				</div>
			</div>
		</div>
	</div>
</div>
